import { CommonModule } from '@angular/common'
import { Component, EventEmitter, Input, OnDestroy, Output } from '@angular/core'
import { CrewMember } from '@events/models/crew-member.interface'
import { Subject } from 'rxjs'

/**
 * Component that represents an invited or a current workspace member
 */
@Component({
  selector: 'ngx-invite-item',
  templateUrl: './invite-item.component.html',
  styleUrls: ['./invite-item.component.scss'],
  standalone: true,
  imports: [CommonModule]
})
export class InviteItemComponent implements OnDestroy {
  /** Subject that stops all hot observables */
  private _destroy$ = new Subject()
  /** On destroy implementation */
  ngOnDestroy() {
    this._destroy$.next(null)
    this._destroy$.complete()
  }
  /**
   * Member details - any type is used cause it's versatile
   */
  @Input()
  member: any
  /**
   * Show alternative mode
   */
  @Input()
  alternative: boolean
  /**
   * Enable select mode
   */
  @Input()
  selectMode = false
  /**
   * Emits whether an item is selected
   */
  @Output()
  selected: EventEmitter<CrewMember> = new EventEmitter<CrewMember>()
  /**
   * Event slug
   */
  @Input()
  eventSlug: string

  /**
   * Invite item label
   */
  public get label() {
    return this.member.name || this.member.email
  }

  /**
   * Selects the invite item and emits the event
   * @returns void
   */
  onSelect() {
    if (!this.selectMode) {
      return
    }
    this.selected.emit(this.member)
  }
}
